const INTEGRATION_NAME = 'VercelAI';

export { INTEGRATION_NAME };
//# sourceMappingURL=constants.js.map
